<template>
	<div>
		<v-app-bar
			app
			color="primary"
			dark
		>
			<!-- モバイル用ハンバーガーメニューアイコン -->
			<v-app-bar-nav-icon
				@click="drawer = true"
				class="hidden-sm-and-up"
			/>

			<v-toolbar-title
				id="title"
				@click="clickTitle()"
			>
				Phantom Horizon
			</v-toolbar-title>

			<!-- PC表示 -->
			<v-tabs
				background-color="transparent"
				color="white"
				class="hidden-xs-only"
			>

				<v-divider vertical />
				<v-tab
					text
					to="/"
				>
					TOP
				</v-tab>

				<v-divider vertical />

				<v-tab
					text
					to="/about"
				>
					ABOUT
				</v-tab>

				<v-divider vertical />

				<v-tab
					text
					to="/danoni"
				>
					DANONI
				</v-tab>
				<v-divider vertical />
			</v-tabs>

			<v-spacer></v-spacer>

			<v-switch
				class="my-auto"
				color="accent"
				label="Dark Mode"
				v-model="darkMode"
				hide-details
			>
			</v-switch>

		</v-app-bar>

		<!-- ハンバーガーメニュー -->
		<v-navigation-drawer
			v-model="drawer"
			absolute
			temporary
		>
			<v-list
				nav
			>
				<v-list-item-group>
					<!-- HOME -->
					<v-list-item
						to="/"
					>
						<v-list-item-icon>
							<v-icon>mdi-home</v-icon>
						</v-list-item-icon>
						<v-list-item-title>HOME</v-list-item-title>
					</v-list-item>

					<!-- ABOUT -->
					<v-list-item
						to="/about"
					>
						<v-list-item-icon>
							<v-icon>mdi-information</v-icon>
						</v-list-item-icon>
						<v-list-item-title>ABOUT</v-list-item-title>
					</v-list-item>

					<!-- DANONI -->
					<v-list-item
						to="/danoni"
					>
						<v-list-item-icon>
							<v-icon>mdi-arrow-up-thick</v-icon>
						</v-list-item-icon>
						<v-list-item-title>DANONI</v-list-item-title>
					</v-list-item>

				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
	</div>
	
</template>

<script>
import router from '../router/index';
export default {
	data: () => {
		return {
			drawer: false,
			darkMode: false,
		}
	},
	computed: {
		theme() {
			return this.$vuetify.theme.dark ? "dark" : "light";
    },
	},
	methods: {
		clickTitle() {
			router.push('/');
		}
	},
	mounted() {
		if(localStorage.isDarkMode) {
			// 'false' → true なので真偽値ではなく文字列で分岐させる
			if(localStorage.isDarkMode === 'true') {
				this.darkMode = true;
			} else {
				this.darkMode = false;
			}
			
		}
	},
	watch: {
		darkMode(isDarkMode) {
			if(isDarkMode) {
				localStorage.isDarkMode = true;
				this.$vuetify.theme.dark = true;
			} else {
				localStorage.isDarkMode = false;
				this.$vuetify.theme.dark = false;
			}
		}
	}
}
</script>

<style scoped>
	#title {
		width: 290px;
		cursor: pointer;
	}
</style>